import React from 'react';
import PropTypes from 'prop-types';
import PageBar from '../../../components/Layout/PageBar';
import Sidebar from './Sidebar';

const Layout = ({ title, description, children, sidebar }) => {
  return (
    <div className="flex-1 cluster-0 -mx-4 -my-6 overflow-hidden">
      <Sidebar
        mode={sidebar.mode}
        onSetMode={sidebar.onSetMode}
        statistics={sidebar.statistics}
        filters={sidebar.filters}
      />
      <div className="stack-0 overflow-hidden w-full">
        <PageBar title={title} description={description} isNewPresentation />
        <div className="p-4 overflow-y-auto">{children}</div>
      </div>
    </div>
  );
};

Layout.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  children: PropTypes.node.isRequired,
  sidebar: PropTypes.shape({
    mode: PropTypes.oneOf(['table', 'calendar']),
    onSetMode: PropTypes.func,
    statistics: PropTypes.node,
    filters: PropTypes.node,
  }),
};

Layout.defaultProps = {
  description: null,
  sidebar: {},
};

export default Layout;
